import { defineMessages } from 'react-intl'

import { CompanyV2VerticalInput } from 'gql/generated/graphql'

export const verticalMessages = defineMessages({
  [CompanyV2VerticalInput.City]: {
    id: 'companies.new.form.vertical.city',
    defaultMessage: 'City'
  },
  [CompanyV2VerticalInput.Team]: {
    id: 'companies.new.form.vertical.team',
    defaultMessage: 'Teams'
  },
  [CompanyV2VerticalInput.Rental]: {
    id: 'companies.new.form.vertical.rental',
    defaultMessage: 'Rentals'
  },
  [CompanyV2VerticalInput.Travel]: {
    id: 'companies.new.form.vertical.travel',
    defaultMessage: 'Travel'
  },
  [CompanyV2VerticalInput.Mobile]: {
    id: 'companies.new.form.vertical.mobile',
    defaultMessage: 'Mobile'
  }
})
